import React from 'react';
import { styled } from 'styled-components';
import { IconText } from './IconText';
import { jsx as _jsx } from "react/jsx-runtime";
export const IconTextWrapper = ({
  onClick,
  ...rest
}) => /*#__PURE__*/_jsx(Wrapper, {
  onClick: onClick,
  children: /*#__PURE__*/_jsx(IconText, {
    ...rest
  })
});
const Wrapper = styled.div.withConfig({
  displayName: "IconTextWrapper__Wrapper",
  componentId: "sc-8wl0dd-0"
})(["display:flex;align-items:center;"]);